import React from "react";
import {
  Clock3,
  Euro,
  Bot,
  BarChart3,
  Sparkles,
  ArrowRight,
} from "lucide-react";
import bg_ai from "../../Images/bg-ai.png";
import CalendlyButton from "../Shared/CalendlyButton";
export default function NoCRMProblem({ imageSrc = bg_ai }) {
  return (
    <section className="relative overflow-hidden pt-24   bg-[#081a2b]">
      {/* Background: stars + grid + glow */}
      <div className="w-[90%] 2xl:w-[70%] mx-auto">
        <div className="pointer-events-none absolute inset-0">
          {/* soft vignette */}
          <div className="absolute inset-0 bg-[radial-gradient(1000px_600px_at_20%_10%,rgba(255,255,255,0.08),transparent_55%),radial-gradient(900px_500px_at_70%_60%,rgba(191,227,98,0.10),transparent_55%)]" />
          {/* subtle grid */}
          <div className="absolute inset-0 opacity-[0.18] [background-image:linear-gradient(to_right,rgba(255,255,255,0.10)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.10)_1px,transparent_1px)] [background-size:60px_60px]" />
          {/* star noise (simple) */}
          <div className="absolute inset-0 opacity-[0.12] [background-image:radial-gradient(rgba(255,255,255,0.9)_1px,transparent_1px)] [background-size:22px_22px]" />
          {/* bottom fade */}
          <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-[#061323] to-transparent" />
        </div>

        <div className="relative mx-auto   py-8 2xl:py-16 ">
          <div className="grid items-center gap-10 lg:grid-cols-2">
            {/* LEFT */}
            <div>
              <h2 className="h2-mb h2-md h2-lg h2-2xl !text-white">
                Automatisieren Sie{" "}
                <span className="text-[#BFE362]">manuelle Prozesse</span> –
                sparen Sie <span className="text-[#BFE362]">Zeit, Kosten</span>{" "}
                und <span className="text-[#BFE362]">Nerven</span> mit KI
              </h2>

              <p className="mt-6 max-w-xl text-base leading-relaxed text-white/75 sm:text-lg">
                Wir entwickeln individuelle KI-Automatisierungen für Marketing,
                Vertrieb und interne Abläufe – damit Ihr Team sich auf das
                Wesentliche konzentriert.
              </p>

              {/* Divider line like screenshot */}
              <div className="mt-8 h-px w-full max-w-xl bg-white/10" />

              {/* Bullet list */}
              <ul className="mt-8 space-y-7">
                <FeatureItem
                  icon={<Clock3 className="h-6 w-6 text-[#BFE362]" />}
                  title={
                    <>
                      Bis zu <span className="text-[#BFE362]">70 %</span>{" "}
                      Zeitersparnis bei wiederkehrenden Aufgaben
                    </>
                  }
                  subtitle=""
                />
                <FeatureItem
                  icon={<Euro className="h-6 w-6 text-[#BFE362]" />}
                  title="Weniger Personalkosten & Fehler"
                  subtitle=""
                />
                <FeatureItem
                  icon={<Bot className="h-6 w-6 text-[#BFE362]" />}
                  title={
                    <>
                      Individuelle{" "}
                      <span className="text-[#BFE362]">
                        KI-Agenten statt Standard-Tools
                      </span>
                    </>
                  }
                  subtitle=""
                />
                <FeatureItem
                  icon={<BarChart3 className="h-6 w-6 text-[#BFE362]" />}
                  title="Skalierbar – ohne mehr Mitarbeiter"
                  subtitle=""
                />
              </ul>
 
              {/* Optional CTA row (you can delete if you want exact screenshot) */}
              <div className="mt-10 flex flex-wrap gap-3">
                {/* <button className="group inline-flex items-center gap-2 rounded-xl bg-[#BFE362] px-5 py-3 text-sm font-semibold text-[#081a2b] shadow-[0_0_0_1px_rgba(191,227,98,0.25),0_18px_60px_rgba(191,227,98,0.18)] transition hover:brightness-105">
                  Kostenlose Prozessanalyse buchen
                  <ArrowRight className="h-4 w-4 transition group-hover:translate-x-0.5" />
                </button> */}
                <CalendlyButton text="Kostenloses Erstgespräch" />
                
              </div>
            </div>

            {/* RIGHT */}
            <div className="relative">
              {/* floating green badge */}

              {/* image card */}
              <div className="relative overflow-hidden   ">
                {/* inner glow border */}
                <div />

                <div className="relative  w-full">
                  {/* Your image */}
                  <img
                    src={imageSrc}
                    alt="KI Automatisierung Visual"
                    className="h-full w-full object-cover"
                  />

                  {/* subtle overlay so it matches the space vibe */}
                  <div className="pointer-events-none absolute inset-0 bg-gradient-to-tr from-[#081a2b]/35 via-transparent to-[#BFE362]/10" />
                </div>
              </div>

              {/* bottom glow line */}
              <div className="pointer-events-none absolute -bottom-10 left-10 right-10 h-20 bg-[radial-gradient(closest-side,rgba(191,227,98,0.25),transparent)] blur-2xl" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function FeatureItem({ icon, title, subtitle }) {
  return (
    <li className="flex gap-4 items-center">
      <div className="mt-0.5 flex h-11 w-11 items-center justify-center rounded-2xl bg-white/5 ring-1 ring-white/10">
        {icon}
      </div>

      <div>
        <div className="text-base font-bold text-white sm:text-lg">{title}</div>
      </div>
    </li>
  );
}
